/* eslint-disable max-len */
import cx from 'clsx';

// types
// styles
import { useStyles } from './shared/styles';

const CheckedCircleOutlined = ({ className, color, onClick }) => {
  const classes = useStyles();
  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10655_8013)">
        <path
          d="M10 18.3333C5.39751 18.3333 1.66667 14.6025 1.66667 10C1.66667 5.39751 5.39751 1.66667 10 1.66667C14.6025 1.66667 18.3333 5.39751 18.3333 10C18.3333 14.6025 14.6025 18.3333 10 18.3333ZM10 16.6667C11.7681 16.6667 13.4638 15.9643 14.7141 14.7141C15.9643 13.4638 16.6667 11.7681 16.6667 10C16.6667 8.2319 15.9643 6.5362 14.7141 5.28596C13.4638 4.03572 11.7681 3.33334 10 3.33334C8.2319 3.33334 6.5362 4.03572 5.28596 5.28596C4.03572 6.5362 3.33334 8.2319 3.33334 10C3.33334 11.7681 4.03572 13.4638 5.28596 14.7141C6.5362 15.9643 8.2319 16.6667 10 16.6667ZM9.16917 13.3333L5.63334 9.79751L6.81167 8.61917L9.16917 10.9767L13.8825 6.26251L15.0617 7.44084L9.16917 13.3333Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_10655_8013">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckedCircleOutlined;
